const globalState = {
    userConfig: null,
    filterBy: null,
    searchBy: null,
    userInfo: null
}

export {globalState}